import React from 'react';
import Lottie from 'lottie-react';
import soundAnimation from '../../assets/SoundAnimation.json';

interface SoundWaveProps {
  color?: string;
}

const SoundWave: React.FC<SoundWaveProps> = ({
  color = 'white',
}) => {
  // Convert hex color to RGB for filter
  const hexToRgb = (hex: string) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : null;
  };

  const rgb = hexToRgb(color);
  const filter = rgb
    ? `brightness(0) saturate(100%) invert(${rgb.r / 255}) sepia(${
        rgb.g / 255
      }) saturate(${rgb.b / 255}) hue-rotate(0deg) brightness(100%) contrast(100%)`
    : 'brightness(0) saturate(100%) invert(1) sepia(0) saturate(0) hue-rotate(0deg) brightness(100%) contrast(100%)';

  return (
      <Lottie
        animationData={soundAnimation}
        loop={true}
        style={{ 
          filter,
          height: "4rem",
        }}
      />
  );
};

export default SoundWave; 